import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom'
import React, { Suspense } from 'react'

// import Users from './users/pages/Users'
// import NewPlace from './places/pages/NewPlace'
import MainNavigation from './shared/components/Navigation/MainNavigation'
// import UserPlace from './places/pages/UserPlaces'
// import UpdatePlace from './places/pages/UpdatePlace'
// import Auth from './users/pages/Auth'
import { AuthContext } from './shared/context/auth-context'
import { useAuth } from './shared/Hooks/auth-hook'
import LoadingSpinner from './shared/components/UIElements/LoadingSpinner'

const Auth = React.lazy(() => import('./users/pages/Auth'))
const Users = React.lazy(() => import('./users/pages/Users'))
const NewPlace = React.lazy(() => import('./places/pages/NewPlace'))
const UserPlace = React.lazy(() => import('./places/pages/UserPlaces'))
const UpdatePlace = React.lazy(() => import('./places/pages/UpdatePlace'))

function App() {
  const { token, userId, login, logout } = useAuth()

  let routes

  if (!token) {
    routes = (
      <Switch>
        <Route path="/" exact>
          <Users />
        </Route>
        <Route path="/:userid/places">
          <UserPlace />
        </Route>
        <Route to="/auth" exact>
          <Auth />
        </Route>
        <Redirect to="/auth" exact />
      </Switch>
    )
  } else {
    routes = (
      <Switch>
        <Route path="/" exact>
          <Users />
        </Route>
        <Route path="/:userid/places">
          <UserPlace />
        </Route>
        <Route path="/places/new" exact>
          <NewPlace />
        </Route>
        <Route path="/places/:placeid">
          <UpdatePlace />
        </Route>
        <Redirect to="/" />
      </Switch>
    )
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        login: login,
        logout: logout,
      }}
    >
      <Router>
        <MainNavigation />
        <main className="app-main">
          <div className="container">
            <Suspense
              fallback={
                <div className="center">
                  <LoadingSpinner />
                </div>
              }
            >
              {routes}
            </Suspense>
          </div>
        </main>
      </Router>
    </AuthContext.Provider>
  )
}

export default App
